import { Subject } from 'rxjs';
import { HdWizard } from './hd-wizard';

import { HdWizardStepTree } from './interface';


export class HdWizardStepController {
  complete = new Subject<any>();
  back = new Subject<string>();
  title = new Subject<string>();
  skip = new Subject<void>();
  dirty = new Subject<void>();
  closeWizard = new Subject<void>();
  unsavedData: any;

  constructor(
    private _wizardInstance: HdWizard,
    public params: any,
    public data: any,
    public trackedValue: any,
    public isFinal = false,
    public isFirst = true
  ) {
  }

  markAsComplete() {
    this.complete.next();
  }

  skipStep() {
    this.skip.next();
  }

  goBack() {
    this.back.next();
  }

  setTitle(value: string) {
    this.title.next(value);
  }

  setDirty() {
    this.dirty.next();
  }

  saveGlobalData(key: string | number, value: any) {
    this._wizardInstance.stepTracker.saveData(key, value);
  }

  updateWizardStepGroups(stepGroups: HdWizardStepTree) {
    this._wizardInstance.stepTracker.updateWizardStepTree(stepGroups);
  }

  getStepTracker() {
    return this._wizardInstance.stepTracker;
  }

  setCloseWizard() {
    this.closeWizard.next();
  }

  getWizardController() {
    return this._wizardInstance.getController();
  }
}
